import { render, staticRenderFns } from "./guests.vue?vue&type=template&id=888aeafc&"
import script from "./guests.vue?vue&type=script&lang=js&"
export * from "./guests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports